/*!
 * Javascript Cookie v1.5.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
  var jQuery;
  if (typeof define === "function" && define.amd) {
    // AMD (Register as an anonymous module)
    define(["jquery"], factory);
  } else if (typeof exports === "object") {
    // Node/CommonJS
    try {
      jQuery = require("jquery");
    } catch (e) {}
    module.exports = factory(jQuery);
  } else {
    // Browser globals
    var _OldCookies = window.Cookies;
    var api = (window.Cookies = factory(window.jQuery));
    api.noConflict = function () {
      window.Cookies = _OldCookies;
      return api;
    };
  }
})(function ($) {
  var pluses = /\+/g;

  function encode(s) {
    return api.raw ? s : encodeURIComponent(s);
  }

  function decode(s) {
    return api.raw ? s : decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(api.json ? JSON.stringify(value) : String(value));
  }

  function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape...
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
    }

    try {
      // Replace server-side written pluses with spaces.
      // If we can't decode the cookie, ignore it, it's unusable.
      // If we can't parse the cookie, ignore it, it's unusable.
      s = decodeURIComponent(s.replace(pluses, " "));
      return api.json ? JSON.parse(s) : s;
    } catch (e) {}
  }

  function read(s, converter) {
    var value = api.raw ? s : parseCookieValue(s);
    return isFunction(converter) ? converter(value) : value;
  }

  function extend() {
    var key, options;
    var i = 0;
    var result = {};
    for (; i < arguments.length; i++) {
      options = arguments[i];
      for (key in options) {
        result[key] = options[key];
      }
    }
    return result;
  }

  function isFunction(obj) {
    return Object.prototype.toString.call(obj) === "[object Function]";
  }

  var api = function (key, value, options) {
    // Write

    if (arguments.length > 1 && !isFunction(value)) {
      options = extend(api.defaults, options);

      if (typeof options.expires === "number") {
        var days = options.expires,
          t = (options.expires = new Date());
        t.setMilliseconds(t.getMilliseconds() + days * 864e5);
      }

      return (document.cookie = [
        encode(key),
        "=",
        stringifyCookieValue(value),
        options.expires ? "; expires=" + options.expires.toUTCString() : "", // use expires attribute, max-age is not supported by IE
        options.path ? "; path=" + options.path : "",
        options.domain ? "; domain=" + options.domain : "",
        options.secure ? "; secure" : "",
      ].join(""));
    }

    // Read

    var result = key ? undefined : {},
      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling "get()".
      cookies = document.cookie ? document.cookie.split("; ") : [],
      i = 0,
      l = cookies.length;

    for (; i < l; i++) {
      var parts = cookies[i].split("="),
        name = decode(parts.shift()),
        cookie = parts.join("=");

      if (key === name) {
        // If second argument (value) is a function it's a converter...
        result = read(cookie, value);
        break;
      }

      // Prevent storing a cookie that we couldn't decode.
      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }

    return result;
  };

  api.get = api.set = api;
  api.defaults = {};

  api.remove = function (key, options) {
    // Must not alter options, thus extending a fresh object...
    api(key, "", extend(options, { expires: -1 }));
    return !api(key);
  };

  if ($) {
    $.cookie = api;
    $.removeCookie = api.remove;
  }

  return api;
});
